import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { get } from 'lodash-es';
import BaseList from '../../base/BaseList';
import { API_HOST, UserContext } from '../../consts';
import Loading from '../../components/Loading';
import ListItem from '../../containers/ListItem';
import NavBreadCrumb from '../../containers/NavBreadCrumb';
import moment from 'moment';
import { toast } from 'react-toastify';
import FiltroRecurso from './FiltroRecurso';
import FilterBox from '../../components/FilterBox';
import { UncontrolledDropdown } from 'reactstrap';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import DropdownItem from 'reactstrap/lib/DropdownItem';
import Axios from 'axios';
import ItemActionAppealModal from '../itens/ItemActionAppealModal';

class ListaRecursos extends BaseList {
  constructor(props) {
    super(props);
    this.params = {};
    this.toggleModal = this.toggleModal.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.selecionarTodos = this.selecionarTodos.bind(this);
    this.api = `${API_HOST}/recursos/recurso`;
    this.state = {
      data: [],
      search: '',
      showContent: false,
      page: 1,
      ordering: '-criado_em',
      showActions: true,
      show_id: null,
      filterBoxes: [],
      isAvancado: false,
      checked: {},
      idsSelecionados: [],
      arquivos: [],
      uploading: false,
      progressEvent: null,
    };
  }

  maisAntigos = 'criado_em';
  maisRecentes = '-criado_em';

  removeConfirmationMessage = (id) =>
    `Tem certeza que deseja remover o recurso ${id}?`;

  renderAddButton() {
    return (
      <Link to="/recursos/new" className="btn primary-button">
        <i className="fas fa-plus" /> Novo Recurso
      </Link>
    );
  }

  renderReplyButton(recurso) {
    const dataLimiteStr = moment(
      get(recurso, 'data_limite'),
      'DD/MM/YYYY'
    ).format('YYYYMMDD');
    const hojeStr = moment(new Date()).format('YYYYMMDD');

    if (dataLimiteStr >= hojeStr) {
      this.props.history.push(`/recursos-elaborador/${get(recurso, 'id')}`);
    } else {
      toast.error(
        'A data limite de resposta para este recurso já foi atingida.'
      );
    }
  }

  showMoreHandle(event) {
    const { show_id } = this.state;
    event.preventDefault();
    const showContent = !this.state.showContent;

    this.setState({
      showContent,
      show_id: show_id === event.target.id ? null : event.target.id
    });
  }

  getActions = (recurso) => {
    const id = get(recurso, 'id');
    const permissions = get(recurso, 'permissions') || [];
    const user = get(this.props, 'user.groups');
    const userId = get(this.props, 'user.id');

    const permissionsUser = get(this.props, 'permissions') || {};
    const getAllPermissions = get(permissionsUser, '__all__');
    const actions = [];

    actions.push(
      <button
        className="btn btn-white mb-3"
        id={get(recurso, 'id')}
        onClick={(event) => this.showMoreHandle(event)}
      >
        <i className="fa fa-eye"></i>
      </button>
    );

    if (
      user &&
      user.filter((d) => d.id === 1) &&
      getAllPermissions &&
      recurso.status.id === 1
    ) {
      actions.push(
        <Link className="btn btn-white mb-3" key="1" to={`recursos/${id}`}>
          <i className="fas fa-edit" />
        </Link>
      );
    }

    if (
      getAllPermissions ||
      get(permissionsUser, 'recursos.reply_recurso') ||
      (userId == recurso.elaborador_id && recurso.status.id === 1)
    ) {
      actions.push(
        <button
          className="btn btn-white mb-3"
          key="2"
          onClick={() => this.renderReplyButton(recurso)}
        >
          <i className="fa fa-reply"></i>
        </button>
      );
    }

    actions.push(
      <button
        className="btn btn-white mb-3"
        key="3"
        onClick={() => window.open(`/recurso-print/${get(recurso, 'id')}`)}
      >
        <i className="fa fa-print"></i>
      </button>
    );

    if (get(permissions, 'destroy') && recurso.status.id !== 2) {
      actions.push(
        <button
          className="btn btn-white mb-3"
          key="4"
          onClick={() => this.handleRemove(id)}
        >
          <i className="fas fa-times" />
        </button>
      );
    }

    return actions;
  };

  notificarElaboradores = () => {
    const { checked, idsSelecionados } = this.state;
    let recursos;
    if (idsSelecionados.length > 0) {
      recursos = idsSelecionados;
    } else {
      recursos = Object.entries(checked)
        .filter((d) => d[1])
        .map((d) => d[0]);
    }
    Axios.post(`${API_HOST}/recursos/recurso/enviar_notificacao`, recursos)
      .then(() => {
        toast.success('Notificações enviadas com sucesso.');
      })
      .catch((error) => {
        console.error(error);
        toast.error('Erro ao enviar notificações.');
      });
  };

  exportarExcel = () => {
    const { checked, idsSelecionados } = this.state;
    let recursos;
    if (idsSelecionados.length > 0) {
      recursos = idsSelecionados;
    } else {
      recursos = Object.entries(checked)
        .filter((d) => d[1])
        .map((d) => d[0]);
    }
    const body = {
      recursos,
      params: this.params,
    };
    Axios.post(`${API_HOST}/recursos/recurso/exportar_excel`, body, {
      responseType: 'blob'
    })
      .then((response) => {
        const blob = new Blob([response.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        let filename = 'recursos.xlsx';
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        toast.success('Excel exportado com sucesso.');
      })
      .catch((error) => {
        console.error(error);
        toast.error('Erro ao exportar Excel.');
      });
  };

  uploadArquivo = (event) => {
    const file = get(event, 'target.files.0');

    if (file) {
      // validar extensão/mimetype antes de enviar
      const ext = (file.name || '').split('.').pop().toLowerCase();
      const allowedExt = ['xlsx', 'xls'];
      const allowedTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
      ];
      if (!allowedExt.includes(ext) && !allowedTypes.includes(file.type)) {
        toast.error('Por favor envie um arquivo Excel (.xlsx ou .xls).');
        return;
      }

      this.setState({ uploading: true });

      const data = new FormData();
      data.append('file', file);
      Axios.post(`${API_HOST}/recursos/recurso/importar_excel`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent) {
            this.setState({ progressEvent });
          }
        },
      })
        .then(() => {
          const { arquivos } = this.state;
          toast.success('Recursos importados com sucesso.');
          this.setState({
            arquivos: [{ name: file.name }, ...arquivos],
            uploading: false,
          });
          this.fetchData();
        })
        .catch((err) => {
          const errors = get(err, 'response.data.file') || get(err, 'response.data');
          const message = Array.isArray(errors)
            ? errors.slice(0, 5).join('\n') + (errors.length > 5 ? `\n... e mais ${errors.length - 5} erro(s).` : '')
            : 'Ocorreu um erro inesperado.';
          toast.error(<div style={{ whiteSpace: 'pre-line' }}>{message}</div>);
          this.setState({ uploading: false });
        });
    }
  }

  selecionarTodos(event) {
    const { checked: isChecked } = event.target;
    const checked = {};
    const idsSelecionados = [];

    Array.from(document.querySelectorAll('[id^="checkbox-"]')).forEach(
      (checkbox) => {
        const id = checkbox.id.replace('checkbox-', '');
        checked[id] = isChecked;

        if (isChecked) {
          idsSelecionados.push(id);
        }
      }
    );

    this.setState({ checked, idsSelecionados });
  }

  renderToolbar() {
    const { search, openModal, arquivos = [], uploading, progressEvent } = this.state;
    const permissions = get(this.props, 'permissions') || {};
    const getAllPermissions = get(permissions, '__all__');
    return (
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center">
          <label className="container-check-custom">
            <input
              type="checkbox"
              id="selecionar-todos"
              aria-label=""
              onChange={this.selecionarTodos}
            />
            <span className="checkmark" />
          </label>
          {getAllPermissions || get(permissions, 'recursos.add_recurso') ? (
            <>{this.renderAddButton()}</>
          ) : null}
          <div>
            <UncontrolledDropdown>
              <DropdownToggle caret className="btn-white ml-2">
                Ações
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={this.notificarElaboradores}>
                  Notificar Elaboradores
                </DropdownItem>
                <DropdownItem onClick={this.exportarExcel}>
                  Exportar para Excel
                </DropdownItem>
                <DropdownItem onClick={() => this.toggleModal('analisar-recurso')}>
                  Deferir/Indeferir Recurso
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
          <div className="d-flex align-items-center ml-2">
            <label
              className={`btn primary-button mb-0 ${uploading ? 'disabled' : ''}`}
              style={{ cursor: uploading ? 'wait' : 'pointer' }}
            >
              {uploading ? (
                <><i className="fas fa-spinner fa-spin mr-2" /> Importando...</>
              ) : (
                <><i className="fas fa-file-upload mr-2" /> Importar Recursos</>
              )}
              <input
                type="file"
                disabled={uploading}
                onChange={this.uploadArquivo}
                style={{ display: 'none' }}
              />
            </label>
            {arquivos.length > 0 && (
              <small
                title={arquivos[0].name}
                className="ml-2 text-muted"
                style={{
                  maxWidth: 220,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                <i className="fas fa-check-circle text-success mr-1" />
                {arquivos[0].name}
              </small>
            )}
          </div>
        </div>
        <div className="d-flex">
          <div className="search">
            <input
              className="search-term"
              placeholder="Pesquisar..."
              value={search}
              onChange={(event) => {
                const search = event.target.value;
                this.setState({ search });
                this.debouncedFetchData(search);
              }}
            />
          </div>
          <div style={{ marginLeft: '5px' }}>
            <button
              type="button"
              onClick={() => this.toggleModal('filtroRecurso')}
              className="btn btn-white"
            >
              <i className="fas fa-filter" /> Filtro
            </button>
          </div>
          {this.renderOrderingSelect()}

          <ItemActionAppealModal
            idsSelecionados={this.state.idsSelecionados}
            isOpen={openModal === 'analisar-recurso'}
            toggle={() => this.toggleModal('analisar-recurso')}
            onSuccess={() => {
              this.toggleModal('analisar-recurso');
              this.fetchData();
            }}
            title="Analisar Recurso"
          />
        </div>
      </div>
    );
  }

  toggleModal(name) {
    const { openModal } = this.state;
    this.setState({ openModal: openModal === name ? null : name });
  }

  updateFilterBoxes = (filterBoxes) => {
    this.setState({ filterBoxes });
  };

  removeFilter(field) {
    this.setState({ filterToRemove: field });
  }

  buscarRecursos = (values) => {
    this.params = { ...values };
    this.fetchData();
  };

  limparFiltros = () => {
    this.params = {};
    const { history, location } = this.props;
    this.setState({ filterBoxes: [] });
    history.push(location.pathname);
    this.fetchData();
  };

  handleChecked(event, id) {
    const checked = {
      ...this.state.checked,
      [id]: event.target.checked
    };
    const idsSelecionados = Object.entries(checked)
      .filter((d) => d[1])
      .map((d) => d[0]);

    this.setState({ checked, idsSelecionados });
  }

  renderList() {
    const {
      fetchingData,
      data,
      showContent,
      show_id,
      openModal,
      filterToRemove,
      filterBoxes,
      checked
    } = this.state;

    if (fetchingData) return <Loading />;
    return (
      <>
        {filterBoxes.map((d) => (
          <FilterBox
            key={d.field}
            onClick={() => this.removeFilter(d.field)}
            className="mr-1 mb-1"
            {...d}
          />
        ))}
        {Object.keys(this.params).length > 0 && (
          <div className="row">
            <div className="col-2">
              <button
                className="btn btn-white mb-3"
                onClick={this.limparFiltros}
              >
                <i className="fas fa-eraser" /> Limpar todos os filtros
              </button>
            </div>
          </div>
        )}
        <FiltroRecurso
          isOpen={openModal === 'filtroRecurso'}
          toggle={() => this.toggleModal('filtroRecurso')}
          buscarRecursos={this.buscarRecursos}
          updateFilterBoxes={this.updateFilterBoxes}
          filterToRemove={filterToRemove}
        />
        {data.map((recurso) => (
          <ListItem
            className="bg-cinza"
            key={recurso.id}
            recurso={recurso}
            showContent={showContent}
            show_id={show_id}
            title={`Recurso ${recurso.id} - item ${get(recurso, 'item', '-')}`}
            status={{
              label: get(recurso, 'status.descricao', '-'),
              color: get(recurso, 'status.cor', '#fff')
            }}
            description={[
              { label: 'Elaborador:', value: get(recurso, 'elaborador', '-') },
              {
                label: 'Disciplina:',
                value: get(recurso, 'aplicacao.disciplina.descricao', '-')
              },
              {
                label: 'Aplicação:',
                value: get(recurso, 'aplicacao.nome', '-')
              },
              { label: 'Data do envio:', value: get(recurso, 'data', '-') },
              {
                label: 'Data limite para resposta:',
                value: get(recurso, 'data_limite', '-')
              }
            ]}
            actions={this.getActions(recurso)}
            checked={checked}
            handleChecked={this.handleChecked}
          />
        ))}
      </>
    );
  }

  renderBreadcrumb() {
    const currentPath = 'Recursos';
    return <NavBreadCrumb currentPath={currentPath} hasBackslash={false} />;
  }
}

export default (props) => (
  <UserContext.Consumer>
    {({ permissions, user }) => (
      <ListaRecursos permissions={permissions} user={user} {...props} />
    )}
  </UserContext.Consumer>
);
